export type WithdrawalMfaTranslations = {
  navTitle: string;
  title: string;
  subtitle: string;
  invalidCode: string;
  confirm: string;
  withdrawalPendingErrorTitle: string;
  withdrawalPendingErrorSubtitle: string;
};

const withdrawalMfaTranslationKeys: WithdrawalMfaTranslations = {
  navTitle: 'confirm_transaction',
  title: '2fa_reset_appcode_title',
  subtitle: 'crypto_withdrawal_2fa_subtitle',
  invalidCode: '2fa_reset_invalid_code',
  confirm: 'confirm',
  withdrawalPendingErrorTitle: 'withdrawal_pending_error_title',
  withdrawalPendingErrorSubtitle: 'withdrawal_pending_error_subtitle',
};

export const getWithdrawalMfaTranslations = (
  t: (key: string) => string,
): WithdrawalMfaTranslations =>
  Object.entries(withdrawalMfaTranslationKeys).reduce((acc, [key, value]) => {
    acc[key as keyof WithdrawalMfaTranslations] = t(value);

    return acc;
  }, {} as WithdrawalMfaTranslations);
